import http from '../../HttpConfig'
import { APIS_ENDPOINTS } from '../../SERVICE-CONSTANTS'

const Plans_endpoints = APIS_ENDPOINTS.validationPaymen


export const request_getAll = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    Plans_endpoints.getallpayment +
    `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}
export const request_exportpayment = async ({ start, end }: { start: string, end: string }) => {
  return http.get(
    Plans_endpoints.exportpayment + '?start=' + start + '&end=' + end
  )
}